import { Alerts } from '../../component-main';
import { openFlyoutForm } from '../form';
import { FormFieldNoteAttachment, FormFieldNoteBody, FormFieldNoteTitle } from './edit';
import { FormFieldNoteTags } from './tags';
export const addNewNoteForm = (rs) => {
    if (!rs.props.adding) {
        Alerts.Alert({ msg: 'You are not allowed to add notes' });
        return;
    }
    openFlyoutForm({
        title: rs.props.adding.formTitle,
        size: [480, null],
        lblWidth: 40,
        defaultValue: () => ({
            title: '',
            tags: [],
            note: '',
            file: null,
        }),
        formPrompt: rs.props.adding.formPrompt,
        fields: {
            title: FormFieldNoteTitle(),
            tags: FormFieldNoteTags(rs),
            note: FormFieldNoteBody(rs),
            file: FormFieldNoteAttachment(),
        },
        formFixer: (_oldState, newState, changedField) => {
            if (changedField == 'file' && !newState.title && newState.file) {
                return {
                    note: `File: ${newState.file.Filename}`,
                };
            }
            return null;
        },
        onSave: (model, formCallback) => {
            rs.props.adding?.onAdd({
                note: {
                    Title: model.current.title,
                    Note: model.current.note,
                    Tags: model.current.tags,
                    Attachment: model.current.file?.Checksum ?? null,
                },
                onComplete: (newID, result) => {
                    formCallback(result);
                    if (newID) {
                        rs.updateState({
                            selectedNotes: [newID],
                        });
                    }
                },
            });
        },
    });
};
//# sourceMappingURL=add.js.map